/**
 * @fileoverview Nature theme - match plants and nature emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

/**
 * Nature theme with trees, flowers, and plants.
 */
export class NatureTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'nature',
            'Nature',
            allLabels.nature,
            { numPairs: 4, isPremium: false, hasMovement: false, ...options }
        );
    }
}
